<template>
  <div class="host-ad">
    <template>
      <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false" no-data-text="暂无数据">
        <template slot-scope="{ row, index }" slot="title">展商中心顶部banner</template>
        <template slot-scope="{ row, index }" slot="banner">
          <div style="display:flex;align-items:center;padding:10px 0;">
            <img style="width:100%;height:72px;" :src="row.path" @click="visible=true;imgurl=row.path;" />
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="link">{{row.link}}</template>
        <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
        <template slot-scope="{ row, index }" slot="action">
          <span style="color: #1890ff;cursor: pointer;margin-right:10px;" @click="setShow(row)">编辑</span>
          <!-- <span style="display: inline-block;padding: 0 5px;">|</span> -->
          <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
            <span style="color: #f00;cursor: pointer;">删除</span>
          </Poptip>
        </template>
      </Table>
    </template>

    <iModal
      title="查看封面"
      v-model="visible"
      class-name="common-ad-top"
      width="600px"
      footer-hide
    >
      <div style="width:100%;height:100%;">
        <img style="max-width:100%;max-height:100%;" :src="imgurl" />
      </div>
    </iModal>

    <adTopEdit 
      :editShow="editShow"
      v-if="editShow"
      :editInfo="editInfo"
      @close="editShow=false;editInfo=null;$emit('editFinish');"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import adTopEdit from "./ad-top-edit.vue";

export default {
  name: "common-ad-top",
  data() {
    return {
      list: [],
      columns1: [
        {
          title: "广告标题",
          slot: "title",
          key: "title",
          align: "center"
        },
        {
          title: "广告封面",
          slot: "banner",
          key: "banner",
          align: "center"
        },
        {
          title: "链接",
          slot: "link",
          key: "link",
          align: "center"
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      visible: false,
      imgurl: "",
      show: false,
      editShow: false,
      editInfo: null,
    }
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  methods: {
    ...mapActions({
      getCommonAd: "hostCommonModule/getCommonAd",
      delCommonAd: "hostCommonModule/delCommonAd"
    }),
    async init() {
      let req = {
        id: this.exhibitionInfo.id,
        typeid: 2,
      }
      let list = await this.getCommonAd(req);
      this.list = list;
    },
    async setShow(item) {
      this.editInfo = item;
      this.editShow = true;
    },
    async delItem(item) {
      let result = await this.delCommonAd(item.id);
      if (result && result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
  },
  created() {
    this.init();
  },
  components: {
    adTopEdit
  }
}
</script>

<style lang="scss" scoped>
.host-ad {
  min-width: 600px;
  padding: 30px 30px 100px 30px;
}
</style>
<style lang="scss">
  .common-ad-top{
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal{
        top: 0;
    }
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    // IE10+ CSS styles go here
    .common-ad-top{
      display: block;
      .ivu-modal{
        top: 150px;
      }
    }
  }
</style>